import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class ProveedoresService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/proveedores/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/meehbox-dev/src/app/shared/services/api/proveedores.service.ts